export default __webpack_public_path__ + "images/497a38a11dfde2ea334d8b344f95ece5-upload.svg";